import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApi } from '../contexts/ApiContext';
import { updateAuthUser } from './useAuth';

export function useDeleteProfile() {
    const api = useApi();
    const queryClient = useQueryClient();
    const { mutate, mutateAsync, ...mutationResult } = useMutation({
        mutationFn: (data) => api.profile.delete(data),
        onSuccess: () => {
            updateAuthUser(queryClient, null);
        },
    });

    return {
        deleteProfile: mutate,
        deleteProfileAsync: mutateAsync,
        ...mutationResult,
    };
}

export function useUpdateProfile() {
    const api = useApi();
    const queryClient = useQueryClient();
    const { mutate, mutateAsync, ...mutationResult } = useMutation({
        mutationFn: (data) => api.profile.update(data),
        onSuccess: (newUser) => {
            updateAuthUser(queryClient, newUser);
        },
    });

    return {
        updateProfile: mutate,
        updateProfileAsync: mutateAsync,
        ...mutationResult,
    };
}

export function useUpdateAvatar() {
    const api = useApi();
    const queryClient = useQueryClient();
    const { mutate, mutateAsync, ...mutationResult } = useMutation({
        retry: 1,
        mutationFn: (data) => api.profile.avatar(data),
        onSuccess: (newUser) => {
            updateAuthUser(queryClient, newUser);
        },
    });

    return {
        updateAvatar: mutate,
        updateAvatarAsync: mutateAsync,
        ...mutationResult,
    };
}

export function useUpdateContact() {
    const api = useApi();
    const queryClient = useQueryClient();
    const { mutate, mutateAsync, ...mutationResult } = useMutation({
        mutationFn: (data) => api.profile.updateContact(data),
        onSuccess: (newUser) => {
            updateAuthUser(queryClient, newUser);
        },
    });

    return {
        updateContact: mutate,
        updateContactAsync: mutateAsync,
        ...mutationResult,
    };
}

export function useVerifyContact() {
    const api = useApi();
    const queryClient = useQueryClient();
    const { mutate, mutateAsync, ...mutationResult } = useMutation({
        mutationFn: ({ contact, ...data }) => api.profile.verifyContact(contact, data),
        onSuccess: (newUser) => {
            updateAuthUser(queryClient, newUser);
        },
    });

    return {
        verifyContact: mutate,
        verifyContactAsync: mutateAsync,
        ...mutationResult,
    };
}

export function useCancelContact() {
    const api = useApi();
    const queryClient = useQueryClient();
    const { mutate, mutateAsync, ...mutationResult } = useMutation({
        mutationFn: (data) => api.profile.cancelContact(data),
        onSuccess: (newUser) => {
            updateAuthUser(queryClient, newUser);
        },
    });

    return {
        cancelContact: mutate,
        cancelContactAsync: mutateAsync,
        ...mutationResult,
    };
}
